/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useEffect, useRef, useState} from 'react';
import PageBox from "../../layouts/pageBox";
import {ReactComponent as DescEngine} from "../../assets/img/car-description/engine.svg";
import {ReactComponent as DescBody} from "../../assets/img/car-description/body.svg";
import {ReactComponent as Descfuel} from "../../assets/img/car-description/fuel.svg";
import {ReactComponent as DescCc} from "../../assets/img/car-description/cc.svg";
import klm from "../../assets/img/car-description/klm.png";
import {ReactComponent as MapGreen} from "../../assets/img/icons/map-green.svg";
import {ReactComponent as PhoneGreen} from "../../assets/img/icons/phone-green.svg";
import {ReactComponent as TimeGreen} from "../../assets/img/icons/time-green.svg";
import {ReactComponent as Camera} from "../../assets/img/icons/camera.svg";
import {ReactComponent as Facebook} from "../../assets/img/icons/facebook.svg";
import {ReactComponent as Mail} from "../../assets/img/icons/send.svg";
import {ReactComponent as NoImage} from "../../assets/img/no_image_car.svg";
import {ReactComponent as Search} from "../../assets/img/icons/search-white.svg";
import {ReactComponent as CheckboxEmpty} from "../../assets/img/forms/checkbox-empty.svg";
import {ReactComponent as CheckboxFull} from "../../assets/img/forms/checkbox-full.svg";
import RequestModal from "../../components/RequestModal";
import {Link, useParams} from "react-router-dom";
import Loader from "../../elements/loader";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {useTranslation} from "react-i18next";
import {ReactComponent as Twitter} from "../../assets/img/social/twitter.svg";
import LoginModal from "../../components/LoginModal";
import {useAuth} from "../../Hooks/useAuth";
import AvailableParts from "./AvailableParts";
import ThumbSlider from "./ThumbSlider";
import SEO from "../../components/SEO";
import JsonLdCarProduct from "../../components/JsonLdCarProduct";

const CarPage = () => {

    let params = useParams();

    const [ad, setAd] = useState({model_year:'', make_title:'', model_name:'' });
    const [merchantInfo, setMerchantInfo] = useState({});
    const [adImages, setAdImages] = useState([]);
    const [makeImage, setMakeImage] = useState({});
    const [criteria, setCriteria] = useState([]);

    const [schedule, setSchedule] = useState([]);
    const [parts, setParts] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const [seoImage, setSeoImage] = useState(null);


    const axiosJWT = useAxiosJTW();
    const { t, i18n } = useTranslation();

    const data = {
        title: `${ad.model_year} ${ad.make_title} ${ad.model_name}`,
        subtitle: `${t('parts.Breakersforparts')} ${ad.model_year} ${ad.make_title} ${ad.model_name}`
    };

    const header = {
        title: `${decodeURIComponent(params.year)} ${decodeURIComponent(params.make)} ${decodeURIComponent(params.model)}`,
        description: 'M7 Salvage have a Salvage Car/ Damaged Repairable 2015 (Oct) NISSAN QASHQAI 1.5L Diesel MPV in their depot at M7 Salvage M7 Slip Road,, Newhall , Naas, Co. Kildare W91 Y77V.',
    }

    const viewad = (signal) => {
        axiosJWT.post('api/viewad', { ad_code : decodeURIComponent(params.ad_code) }, {signal}).then( (response) => {
            if(response.status === 200){
                setAd(response.data.ads[0] || {});
                setAdImages(response.data.ads.images || []);
                setCriteria(response.data.criteria || []);
                setMerchantInfo(response.data.merchant_info || {});
                setParts(response.data.parts || {});
                setSchedule(response.data.schedule || []);
                setMakeImage(response.data.make_logo || '');
                setIsLoading(false);
                setSeoImage(response.data.main_image || null);

            }
        } ).catch((error) => {
            setIsLoading(true);
            setError(true);
        });
    }


    useEffect(() => {
        const controller = new AbortController();
        const signal= controller.signal;

        viewad(signal);

        return () => {controller.abort();}
    }, [params]);


    return (
        <PageBox data={data} showAdds={false}>
            <SEO
                title={ t('meta_title.carPage', {make: ad.make_title, model: ad.model_name, model_year: ad.model_year } )}
                description={ t('meta_description.carPage', { company: ad.company, make: ad.make_title, model: ad.model_name, model_year: ad.model_year } ) }
                image={seoImage}
                type="product"
            />

            <JsonLdCarProduct
                name={`${ad.model_year} ${ad.make_title} ${ad.model_name}`}
                carPagejsonLdTitle={t('meta_description.carPagejsonLdTitle', { make: ad.make_title, model: ad.model_name, model_year: ad.model_year } )}
                description={t('meta_description.carPage', { company: ad.company, make: ad.make_title, model: ad.model_name, model_year: ad.model_year } )}
                carPagejsonLdDescription={t('meta_description.carPage', { make: ad.make_title, model: ad.model_name, model_year: ad.model_year } )}
                publisher={ad.company}
                inLanguage={params.lang || 'el'}
                items={parts}
            />
            {isLoading ? (
                <>
                    <div style={{ paddingTop: '30px', textAlign : 'center', margin: '0 auto' }}><Loader/></div>
                    {error &&<div style={{ paddingTop: '30px', textAlign : 'center', color: 'red' }}>An error has occurred please try again later.</div>}
                </>
            ) : (
                <>
                    <div className='page-header'>
                        {/*<PageHeader data={header}/>*/} {/*  εχει το code αντι του search */}
                        <div className='page-header__row'>
                            <div className='page-header__content'>
                                <div className='page-header__content-row'>
                                    <div className='page-header__icon'><img src={makeImage} alt={`${ad.model_year} ${ad.make_title} ${ad.model_name}`} /> </div>
                                    <div className='page-header__title'>{ad.model_year} {ad.make_title} {ad.model_name}</div>
                                </div>
                                <div className='page-header__description'>{ad.description}</div>
                            </div>
                            <div className='page-header__aside-car'>
                                <div className='system-code'>
                                    <div className='system-code__label'>{t('parts.AdCode')}</div>
                                    <div className='system-code__code-ad'>{ad.code}</div>
                                    <div className='system-code__code-st'>{ad.ad_status_title}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='page-body'>
                        <div className='UsedCar__row row'>
                            <div className='col-lg-6 '>
                                {adImages.length > 0 && <ThumbSlider images={adImages}/>}
                                {adImages.length == 0 && <div className='UsedCar__no-image'><NoImage/></div>}
                            </div>
                            <div className='col-xl-6 UsedCar__description-col'>
                                <div className="UsedPartsTitle">{t('parts.carDescription' ) }</div>
                                <div className='carDescription'>
                                    <div className='carDescription__item'>
                                        <div className='carDescription__icon'><img src={klm} alt='Klm' /></div>
                                        <div className='carDescription__label'>Klm</div>
                                        <div className='carDescription__text'>
                                            {(() => {
                                                switch (ad.klm_status ) {
                                                    case "1":
                                                        return <>-</>;
                                                    default:
                                                        return <>{ad.klm}</>;
                                                }
                                            })()}
                                        </div>
                                    </div>
                                    <div className='carDescription__item'>
                                        <div className='carDescription__icon'><DescEngine/></div>
                                        <div className='carDescription__label'>{t('parts.EngineNumber')}</div>
                                        <div className='carDescription__text'>{ad.engine}</div>
                                    </div>
                                    <div className='carDescription__item'>
                                        <div className='carDescription__icon'><DescBody/></div>
                                        <div className='carDescription__label'>{t('parts.Bodytype')}</div>
                                        <div className='carDescription__text'>{ad.bodytype_title}</div>
                                    </div>
                                    <div className='carDescription__item'>
                                        <div className='carDescription__icon'><Descfuel/></div>
                                        <div className='carDescription__label'>{t('fields.Fuel')}</div>
                                        <div className='carDescription__text'>{ad.fuel_title}</div>
                                    </div>
                                    <div className='carDescription__item'>
                                        <div className='carDescription__icon'><DescCc/></div>
                                        <div className='carDescription__label'>{t('parts.cc')}</div>
                                        <div className='carDescription__text'>{ad.cc_title}</div>
                                    </div>

                                    {criteria.map((item, index) => {
                                        if (item.criteria.length > 0) {
                                            return (
                                                <div className='carDescription__item' key={index}>
                                                    <div className='carDescription__icon'><img src={item.image} alt={item.title} /></div>
                                                    <div className='carDescription__label'>{item.title}</div>
                                                    <div className='carDescription__text'>{item.criteria[0].title}</div>
                                                </div>
                                            );
                                        }

                                        return (
                                            <div className='carDescription__item' key={index}>
                                                <div className='carDescription__icon'><img src={item.image} alt={item.title} /></div>
                                                <div className='carDescription__label'>{item.title}</div>
                                                <div className='carDescription__text'> - </div>
                                            </div>
                                        );
                                    })}

                                </div>
                            </div>
                            <div className='col-xl-12 UsedCar__contact-col'>

                                <div className='UsedCarContact'>

                                    {/*<RequestModal/>*/}

                                    <div className='UsedPartsTitle'>{ t('parts.contactDetails' ) }</div>

                                    <div className='UsedCarContact__header'>
                                        <div className='UsedCarContact__img'>
                                            <div className='UsedCarContact__img-wrap'>
                                                { merchantInfo.logo != "NULL" && <img src={merchantInfo.logo} alt={ad.company} />}
                                            </div>
                                        </div>
                                        <div className='UsedCarContact__content'>
                                            <Link to={`/${i18n.language}/mini-site/cars/${ad.merchant_id}/${ad.merchant_slug}`} className='UsedCarContact__title'> {ad.company}</Link>
                                            <Link to={`/${i18n.language}/mini-site/cars/${ad.merchant_id}/${ad.merchant_slug}`} className='UsedCarContact__view-all'>{ t('parts.Viewallcars' ) }</Link>
                                        </div>
                                    </div>
                                    <div className='UsedPartsAside__body'>

                                        <div className='icon-link'>
                                            <div className='icon-link__icon'><MapGreen/></div>
                                            <div className='icon-link__label icon-link__label--map'>{merchantInfo.city_title}, {merchantInfo.address}, {merchantInfo.postalcode}</div>
                                        </div>

                                        { merchantInfo.contact_choice == 1 && merchantInfo.phone && <div className='icon-link'>
                                            <div className='icon-link__icon'><PhoneGreen/></div>
                                            <a href={`tel:+${merchantInfo.phone_code}${merchantInfo.phone}`} className='icon-link__label small-text icon-link__label--phone'>{merchantInfo.phone}</a>
                                        </div>}
                                        { merchantInfo.contact_choice == 2 && merchantInfo.email && <div className='icon-link'>
                                            <div className='icon-link__icon' style={{color: '#3DD037'}}><Mail/></div>
                                            <a href={`mailto:${merchantInfo.email}`} className='icon-link__label small-text icon-link__label--phone'>{merchantInfo.email}</a>
                                        </div>}

                                        { schedule.length > 0 && <div className='icon-link align-items-start'>
                                            <div className='icon-link__icon' style={{paddingTop: '40px'}} ><TimeGreen/></div>
                                            <div className='icon-link__label time-table-box'>
                                                <div className='row extra-small-gutters p-2'>
                                                    <div className='col-sm-4'></div>
                                                    <div className='col-sm-4'><span className='time-table-box__header'>{t('parts.MorningHours')} </span></div>
                                                    <div className='col-sm-4'><span className='time-table-box__header'>{t('parts.EveningHours')} </span></div>
                                                </div>

                                                { schedule.map( (item, index) => (
                                                        <div className='row extra-small-gutters p-2' key={index}>
                                                            <div className='col-sm-4'><span className='time-table-box__label'>{item.description}:</span></div>
                                                            <div className='col-sm-4'><span className='time-table-box__label'>
                                                                {item.time_morning_from == '-1' ? (
                                                                    <>{t('parts.closed')}</>
                                                                ) : (
                                                                    <>{item.time_morning_from} - {item.time_morning_to}</>
                                                                )}

                                                            </span></div>
                                                            <div className='col-sm-4'><span className='time-table-box__label'>
                                                                {item.time_evening_from == '-1' ? (
                                                                    <>{t('parts.closed')}</>
                                                                ) : (
                                                                    <>{item.time_evening_from} - {item.time_evening_to}</>
                                                                )}

                                                            </span></div>
                                                        </div>
                                                    ) )
                                                }
                                            </div>

                                        </div>}

                                    </div>


                                </div>

                                <div className='shareLinks justify-content-end pt-5'>
                                    <div className='shareLinks__label'>Share</div>
                                    <ul className='shareLinks__list'>
                                        <li className='shareLinks__item'><a href={`https://www.facebook.com/share.php?u=${window.location}`} target='_blank' rel='noopener'><Facebook/></a></li>
                                        <li className='shareLinks__item'><a href={`https://twitter.com/intent/tweet?text=${ad.model_year} ${ad.make_title} ${ad.model_name}&url=${window.location}`} target='_blank' rel='noopener'><Twitter/></a></li>
                                        <li className='shareLinks__item'><a href={`mailto:?subject=${ad.model_year} ${ad.make_title} ${ad.model_name}&body=Check out this ${window.location}`} target='_blank' rel='noopener'><Mail/></a></li>
                                    </ul>
                                </div>

                            </div>
                        </div>



                        <AvailableParts parts={parts} ad={ad} merchantInfo={merchantInfo}/>

                    </div>
                </>
            )}

        </PageBox>
    );
};

export default CarPage;
